module.exports = __webpack_public_path__ + "img/pos-icon-active.edfc541f.svg";